/* eslint-disable jsx-a11y/anchor-is-valid */
import {DialogBox, DialogBoxBody, DialogBoxFooter} from "common/DialogBox"
import {FormErrorBox} from "common/FormErrorBox"
import {RealDevice} from "dto/realdevice/devices"
import {DeviceInput} from "pages/admin/devices/form/DeviceInput"
import {LoraDeviceList} from "pages/admin/devices/lora/LoraDeviceList"
import {KakaoSearchAddressResponse, SearchAddressBox} from "pages/component/SearchAddressBox"
import {useState} from "react";
import {useForm} from "react-hook-form";
import styled from "styled-components"
import {LocalDeviceImageViewer, RemoteDeviceImageViewer} from "pages/admin/devices/form/DeviceImageViewer"
import {Category} from "dto/category/category"
import {useCategories, useInitDefaultFormValues} from "pages/admin/devices/form/hooks/device-form-hooks"
import ReactDatePicker from "react-datepicker";
import dayjs from "dayjs";

interface DeviceFormProps {
    show: boolean
    close: () => void
    device?: RealDevice
    onSubmit: (value: DeviceInput) => void
}

export const RealDeviceForm = ({show, close, device, onSubmit}: DeviceFormProps) => {
    const [searchDate, setSearchDate] = useState<Date>()
    const [title, setTitle] = useState("휠체어(단말기) 등록하기")
    const [editMode, setEditMode] = useState(false)
    const [imgFile, setImgFile] = useState<File>()
    // const [fileResource, setFileResource] = useState<FileResource>()
    const {register, handleSubmit, formState: {errors}, setValue, getValues, watch} = useForm<DeviceInput>()
    const [showAddressBox, setShowAddressBox] = useState<boolean>(false)
    const [showLoraDeviceSelector, setShowLoraDeviceSelector] = useState<boolean>(false)


    const {selectedParentCategoryId, parentCategories, childrenCategories, setSelectedParentCategoryId, categories} = useCategories()
    useInitDefaultFormValues(device, parentCategories, childrenCategories, setValue, setTitle, setEditMode, setSelectedParentCategoryId, setSearchDate)
    const handleSearchAddressResult = (address: KakaoSearchAddressResponse) => {
        setShowAddressBox(false)
        setValue("address", address.address)
    }

    const handleSelectLoraDevice = (eui: string) => {
        setValue("deviceEui", eui)
        setShowLoraDeviceSelector(false)
    }


    const addLoadImgFiles = (files: FileList) => {
        // const imgNames = []
        const imgFiles = getValues("localImgFiles")
        const tmpFiles: File[] = []
        for (let i = 0; i < files.length; i++) {
            const blob = files.item(i)
            if (!blob) continue
            // imgNames[i] = URL.createObjectURL(blob)
            tmpFiles[i] = blob
        }
        setValue("localImgFiles", [...imgFiles || [], ...tmpFiles])
    }

    const removeLocalImgFile = (idx: number) => {
        // imgFileNames.splice(idx, 1)
        // setImgFileNames([...imgFileNames])
        const imgFiles = getValues("localImgFiles")
        if (imgFiles) {
            imgFiles?.splice(idx, 1)
            setValue("localImgFiles", [...imgFiles])
        }
    }

    const removeRemoteImgFile = (idx: number) => {
        const imgFiles = getValues("remoteImgFiles")
        if (imgFiles) {
            imgFiles?.splice(idx, 1)
            setValue("remoteImgFiles", [...imgFiles])
        }
    }

    const selectedFile = getValues("imgFile")

    const localImgFiles = watch("localImgFiles")
    const remoteImgFiles = watch("remoteImgFiles")

    console.log("selected category : ", selectedParentCategoryId)
    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <DialogBox show={show} close={close} title={title} color={"link"}>
                <DialogBoxBody>
                    <div className="columns mb0 mt10">
                        <div className="column columns">
                            <div className=" stitlebox label">장비(단말기) EUI <RequiredMark/></div>
                            <div className="column">
                                <div style={{position: "relative"}}>
                                    <input
                                        {...register("deviceEui", {
                                            required: "단말 EUI를 입력하세요", pattern: {
                                                value: /^[0-9a-fA-F]{16}$/,
                                                message: "단말 EUI는 16자리의 16진수입니다."
                                            }
                                        })}
                                        className="input" type="text" placeholder="장비 EUI"/>
                                    <FormErrorBox error={errors.deviceEui}/>
                                    <div style={{position: "absolute", right: 5, top: 5}}>
                                        <a className="button is-small is-black"
                                           onClick={() => setShowLoraDeviceSelector(true)}>
                                            단말기검색
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="hr-line-dashed"/>
                    <div className="columns mb0">
                        <div className="column columns">
                            <div className=" stitlebox label">전동 보장구 S/N</div>
                            <div className="column">
                                <input
                                    {...register("serialNumber")}
                                    className="input" type="text" placeholder="전동보장구 시리얼번호"/>
                                <FormErrorBox error={errors.serialNumber}/>
                            </div>
                        </div>
                        <div className="column columns">
                            <div className=" stitlebox label" style={{width: 80}}>설치일</div>
                            <div className="column">
                                {/*<input*/}
                                {/*    {...register("serialNumber")}*/}
                                {/*    className="input" type="text" placeholder="전동보장구 시리얼번호"/>*/}
                                <ReactDatePicker
                                    selected={searchDate}
                                    onChange={(date: Date) => {
                                        setSearchDate(date)
                                        setValue('installationDate', date)
                                    }}
                                    className="input group-input"
                                    placeholderText="시작일"
                                    dateFormat="yyyy년 MM월 dd일"
                                />
                                <FormErrorBox error={errors.serialNumber}/>
                            </div>
                        </div>
                    </div>
                    <div className="hr-line-dashed"/>
                    <div className="columns mb0">
                        <div className="column columns">
                            <div className=" stitlebox label">사용자명 <RequiredMark/></div>
                            <div className="column">
                                <input
                                    {...register("name", {
                                        required: "사용자명을 입력하세요",
                                        minLength: {value: 3, message: "사용자명을 3자 이상 입력하세요"}
                                    })}
                                    className="input" type="text" placeholder="사용자명"/>
                                <FormErrorBox error={errors.name}/>
                            </div>
                        </div>
                    </div>
                    <div className="hr-line-dashed"/>
                    <div className="columns mb0">
                        <div className="column columns">
                            <div className=" stitlebox label">카테고리<RequiredMark/></div>
                            <div className="column is-flex">
                                <select
                                    className="mr-3 select is-multiline is-flex-grow-1 is-multiple" placeholder="카테고리"
                                    size={8} style={{height: 100}}>
                                    {parentCategories.map((category: Category) => {
                                        return (
                                            <option
                                                selected={selectedParentCategoryId === category?.id}
                                                value={category.id} key={category.id}
                                                onClick={() => {
                                                    setSelectedParentCategoryId(category?.id)
                                                }}>
                                                {category.name}
                                            </option>
                                        )
                                    })}
                                </select>
                                <select
                                    {...register("categoryId")}
                                    className="mr-3 select is-multiline is-flex-grow-1 is-multiple" placeholder="카테고리"
                                    size={8} style={{height: 100}}>
                                    {childrenCategories.map((category: Category) => {
                                        return (
                                            <option value={category.id} key={category.id}>{category.name}</option>
                                        )
                                    })}
                                </select>

                            </div>
                        </div>
                    </div>
                    <div className="hr-line-dashed"/>
                    <div className="columns mb0">
                        <div className="column columns">
                            <div className=" stitlebox label">단말기 사진</div>
                            {/*{!fileResource && (*/}
                            <div className="column is-two-fifths">
                                <div className="file has-name ">
                                    <label className="file-label">
                                        <input className="file-input" type="file" multiple={true} name="upload"
                                               accept="image/gif, image/jpeg, image/png"
                                               onChange={(e) => {
                                                   if (!e || !e.target || !e.target.files) return
                                                   const files = e.target.files
                                                   if (files.length > 0) {
                                                       // setImgFile(files[0])
                                                       // setValue("imgFile", files[0])
                                                       addLoadImgFiles(files)
                                                   }
                                               }}/>
                                        <span className="file-cta">
                                            <span className="file-icon">
                                                <i className="fas fa-upload"/>
                                            </span>
                                            <span className="file-label">
                                                업로드할 파일을 선택
                                            </span>
                                        </span>
                                        {/*<span className="file-name is-fullwidth">*/}
                                        {/*    {selectedFile && selectedFile.name}*/}
                                        {/*    {!selectedFile && "선택한 이미지가 없습니다"}*/}
                                        {/*</span>*/}
                                    </label>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div className="columns mb0">
                        <div className="column columns">
                            <div className=" stitlebox label"></div>
                            <div className="column"
                                 style={{
                                     border: 'solid #ccc 1px',
                                     borderRadius: 8,
                                     marginTop: 10,
                                     overflow: "hidden",
                                     display: 'flex', minHeight: 120,
                                     flexWrap: 'wrap',
                                     marginLeft: 10,
                                     marginRight: 10,
                                 }}>
                                {
                                    remoteImgFiles?.map((image, index) => {
                                        return (
                                            <RemoteDeviceImageViewer key={image} id={image}
                                                                     onClick={() => removeRemoteImgFile(index)}/>
                                        )
                                    })
                                }
                                {
                                    localImgFiles?.map((image, index) => {
                                        const url = URL.createObjectURL(image)
                                        return (
                                            <LocalDeviceImageViewer key={index} url={url}
                                                                    onClick={() => removeLocalImgFile(index)}/>
                                        )
                                    })
                                }

                                {/*<textarea className="textarea" placeholder="" rows={3}></textarea>*/}
                            </div>
                        </div>
                    </div>
                    <div className="hr-line-dashed"/>
                    <div className="columns mb0">
                        <div className="column columns">
                            <div className=" stitlebox label">사용자연락처 <RequiredMark/></div>
                            <div className="column">
                                <input {...register("mobile", {
                                    required: "사용자 연락처를 입력하세요",
                                    pattern: {
                                        value: /^[0-9]{3}[-]*[0-9]{3,4}[-]*[0-9]{4}$/i,
                                        message: "사용자 연락처 형식이 올바르지 않습니다"
                                    }
                                })}
                                       className="input" type="text" placeholder="사용자연락처"/>
                                <FormErrorBox error={errors.mobile}/>
                            </div>
                        </div>
                    </div>
                    <div className="hr-line-dashed"/>
                    <div className="columns mb0">
                        <div className="column columns">
                            <div className=" stitlebox label">보호자명 </div>
                            <div className="column">
                                <input
                                    {...register("protectorName", {
                                        // required: "보호자명을 입력하세요",
                                        minLength: {value: 3, message: "보호자명을 3자 이상 입력하세요"}
                                    })}
                                    className="input" type="text" placeholder="보호자명"/>
                                <FormErrorBox error={errors.protectorName}/>
                            </div>
                        </div>
                    </div>
                    <div className="hr-line-dashed"/>
                    <div className="columns mb0">
                        <div className="column columns">
                            <div className=" stitlebox label">보호자연락처 </div>
                            <div className="column">
                                <input {...register("protectorMobile", {
                                    // required: "사용자 연락처를 입력하세요",
                                    pattern: {
                                        value: /^[0-9]{3}[-]*[0-9]{3,4}[-]*[0-9]{4}$/i,
                                        message: "보호자 연락처 형식이 올바르지 않습니다"
                                    }
                                })}
                                       className="input" type="text" placeholder="보호자연락처"/>
                                <FormErrorBox error={errors.protectorMobile}/>
                            </div>
                        </div>
                    </div>
                    <div className="hr-line-dashed"/>
                    <div className="columns mb0">
                        <div className="column columns">
                            <div className=" stitlebox label">보호자명(보조) </div>
                            <div className="column">
                                <input
                                    {...register("secondaryProtectorName", {
                                        // required: "보호자명을 입력하세요",
                                        minLength: {value: 3, message: "보호자명을 3자 이상 입력하세요"}
                                    })}
                                    className="input" type="text" placeholder="보호자명(보조)"/>
                                <FormErrorBox error={errors.secondaryProtectorName}/>
                            </div>
                        </div>
                    </div>
                    <div className="hr-line-dashed"/>
                    <div className="columns mb0">
                        <div className="column columns">
                            <div className=" stitlebox label">보호자연락처(보조) </div>
                            <div className="column">
                                <input {...register("secondaryProtectorMobile", {
                                    // required: "사용자 연락처를 입력하세요",
                                    pattern: {
                                        value: /^[0-9]{3}[-]*[0-9]{3,4}[-]*[0-9]{4}$/i,
                                        message: "보호자 연락처 형식이 올바르지 않습니다"
                                    }
                                })}
                                       className="input" type="text" placeholder="보호자연락처(보조)"/>
                                <FormErrorBox error={errors.secondaryProtectorMobile}/>
                            </div>
                        </div>
                    </div>
                    <div className="hr-line-dashed"/>
                    <div className="columns mb0">
                        <div className="column columns">
                            <div className=" stitlebox label">사용자주소</div>
                            <div className="column">
                                <div style={{position: "relative"}}>
                                    <input {...register("address")}
                                           className="input" type="text" placeholder="사용자 주소 입력"
                                           readOnly={true}
                                    />
                                    <div style={{position: "absolute", right: 5, top: 5}}>
                                        <a className="button is-small is-black" onClick={() => setShowAddressBox(true)}>
                                            주소검색
                                        </a>
                                    </div>
                                </div>
                                <input {...register("subAddress")}
                                       className="input" type="text" placeholder="나머지 주소 입력"/>

                            </div>
                        </div>
                    </div>
                    <div className="hr-line-dashed"/>
                    <div className="columns mb0">
                        <div className="column columns ">
                            <div className="stitlebox label">비고</div>
                            <div className="column">
                            <textarea {...register("etc")}
                                      className="textarea" placeholder="" rows={2}/>
                            </div>
                        </div>
                    </div>
                    <div className="hr-line-dashed"/>
                    <div className="columns mb0">
                        <div className="column columns ">
                            <div className="stitlebox label">외부 API 연동 제외</div>
                            <div className="column">
                                <label className="checkbox mt15">
                                    <input type="checkbox"
                                           className="checkbox" {...register("ignoreExternalEmission")}/>
                                    <span className="ml-1">
                                        설정할 경우 넘어짐 이벤트가 발생해도 외부 API에 이벤트를 전달하지 않습니다.
                                    </span>
                                </label>
                            </div>
                        </div>
                    </div>
                </DialogBoxBody>
                <DialogBoxFooter>
                    <button className="button is-success">{editMode ? "단말기수정" : "단말기저장"}</button>
                    <a className="button" onClick={close}>취소</a>
                </DialogBoxFooter>
            </DialogBox>
            {showAddressBox &&
                <SearchAddressBox
                    handleComplete={handleSearchAddressResult}
                    show={showAddressBox}
                    close={() => setShowAddressBox(false)}/>
            }
            {showLoraDeviceSelector &&
                <LoraDeviceList
                    handleComplete={handleSelectLoraDevice}
                    show={showLoraDeviceSelector}
                    close={() => setShowLoraDeviceSelector(false)}/>
            }
        </form>
    );
}

const RequiredMark = () => {
    return (
        <span style={{color: "red"}}>*</span>
    )
}

const ImageBox = styled.div`
  position: relative;
  display: inline-block;
  border: #ffffff solid 1px;

  &:hover {
    border: #00b89c solid 1px;
  }

`